import { sanitizeHtml } from "./sanitize";

// Validate analytics IDs so untrusted values can't be interpolated into inline JS.
const GA_ID = /^(G|UA|AW|DC)-[A-Za-z0-9_-]+$/;
const GTM_ID = /^GTM-[A-Za-z0-9]+$/;

export function injectGA(gaId) {
  if (!gaId || !GA_ID.test(gaId) || document.getElementById("ga-script")) return;
  const s = document.createElement("script");
  s.id = "ga-script";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`;
  document.head.appendChild(s);

  const inline = document.createElement("script");
  inline.id = "ga-inline";
  inline.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config',${JSON.stringify(gaId)});`;
  document.head.appendChild(inline);
}

export function injectGTM(gtmId) {
  if (!gtmId || !GTM_ID.test(gtmId) || document.getElementById("gtm-script")) return;
  const s = document.createElement("script");
  s.id = "gtm-script";
  s.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',${JSON.stringify(gtmId)});`;
  document.head.appendChild(s);
}

export function injectVerification(tag) {
  if (!tag || document.getElementById("gsc-verify")) return;
  const m = document.createElement("meta");
  m.id = "gsc-verify";
  m.name = "google-site-verification";
  m.content = tag; // set via property = safe (no HTML parsing)
  document.head.appendChild(m);
}

export function injectCustomHead(html) {
  if (!html || document.getElementById("custom-head")) return;
  const wrap = document.createElement("div");
  wrap.id = "custom-head";
  wrap.style.display = "none";
  // Sanitize admin-provided markup to strip scripts/handlers (XSS safe).
  wrap.innerHTML = sanitizeHtml(html);
  document.head.appendChild(wrap);
}

export function applySettingsToHead(data) {
  if (!data) return;
  injectGA(data.gaId);
  injectGTM(data.gtmId);
  injectVerification(data.searchConsoleTag);
  injectCustomHead(data.headScripts);
}
